import PureCounter from '@srexi/purecounterjs';

const sectionNumbers = document.querySelectorAll('section.numbers');

document.addEventListener('DOMContentLoaded', () => {
	const pure = new PureCounter({
		formater: 'nl-NL',
		start: 0,
		separator: '.',
	});
});
